<template>
  <div id="UnitPermitDetail">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Unit Permit Detail</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'unitPermitDetail'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'unitPermitDetail'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="unitPermitDetail"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "UnitPermitDetail",
  metaInfo() {
            return {title: "Unit Permit Detail | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action:'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Permit Sequence',
          field: 'permit_seq',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
          // sortable:false,
      },
      {
          label: 'Unit Description',
          field: 'unit_description',
          hidden:false,
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'Permit Number',
          field: 'permit_number',
          hidden:false,
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'Permit Description',
          field: 'description',
          hidden:false,
          fpFieldType:"text",
          filterable: true,
      },
        {
          label: 'Permit Status',
          field: 'status',
          fpFieldType:"option",
          hidden:false,
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['Processed', 'Entry', 'Expired / Cancelled'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Permit Owner',
          field: 'owner',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Permit Type',
          field: 'permit_type',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Plate Type',
          field: 'licence_type',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['F','P'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Permit State',
          field: 'permit_state',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
          // sortable:false,
      },
      {
          label: 'Effective Date',
          field: 'effective_date',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: true,
      },
      {
          label: 'Expiry Date',
          field: 'expiry_date',
          fpFieldType:"custom_date",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Cancel Date',
          field: 'cancel_date',
          fpFieldType:"custom_date",
          hidden:false,
          filterable: true,
      },
      {
          label: 'IRP Fleet',
          field: 'irp_fleet',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable:false,
      },
      {
          label: 'Permit Amount',
          field: 'amount',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
      },
       {
          label: 'Permit Billback',
          field: 'billback_amount',
          hidden:false,
          type:'number',
          fpFieldType:"integer",
          filterable: false,//as real time calc involved for value
          sortable: false, //as real time calc involved for value
      },
      {
          label: 'Amount Amortized',
          field: 'amount_amortized',
          hidden:false,
          type:'number',
          sortable: false,
          fpFieldType:"integer",
          filterable: false,
      },
      {
          label: 'Remaining Amount',
          field: 'remaining_amount',
          hidden:false,
          type:'number',
          fpFieldType:"integer",
          sortable: true,
          filterable: true,
      },
      {
          label: 'Allowance',
          field: 'allowance',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
      },
      {
          label: 'Reportable',
          field: 'reportable',
          hidden:false,
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'Permit Facility',
          field: 'location',
          fpFieldType:"option",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Permit Customer',
          field: 'customer_number',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Permit Customer Name',
          field: 'customer',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'GVW',
          field: 'gross_weight',
          fpFieldType:"integer",
          filterable: true,
          type:'number',
          hidden:false,
      },
      {
          label: 'Tare Weight',
          field: 'tare_weight',
          fpFieldType:"integer",
          filterable: true,
          type:'number',
          hidden:false,
      },
      {
          label: 'Unit Year',
          field: 'year',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Model',
          field: 'model',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Make',
          field: 'manufacturer_code',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Serial Number',
          field: 'vin',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'In Service Date',
          field: 'date_in_service',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: true,
      },
      {
          label: 'Equipment Type',
          field: 'equip_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Equipment Group',
          field: 'equip_grp',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Equipment Comments',
          field: 'equip_comments',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable:false,
      },
      {
          label: 'Contract Type',
          field: 'contract_type',
          hidden:false,
          filterable: true,
          // sortable: false,
          fpFieldType:"text",
      },
      {
          label: 'Agmt Number',
          field: 'agreement_no',
          // sortable: false,
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Facility',
          field: 'vehicle_location',
          fpFieldType:"option",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Pool',
          field: 'pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Current Customer',
          field: 'cur_customer',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
          // sortable:false,
      },
      {
          label: 'Current Customer Name',
          field: 'cur_customer_name',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
          // sortable:false,
      },
      {
          label: 'HVUT Category',
          field: 'hvut_category',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
          // sortable:false,
      },
      {
          label: 'GL Tran',
          field: 'gl_tran',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Invoice',
          field: 'inv',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
          // sortable:false,
      },
      {
          label: 'Process Date',
          field: 'process_dt',
          fpFieldType:"custom_date",
          hidden:false,
          filterable: true,
          // sortable:false,
      },
      {
          label: 'Admin Fee',
          field: 'admin_fee',
          hidden:false,
          type:'number',
          fpFieldType:"integer",
          filterable: true,
      },
      {
          label: 'Contract Expiry Date',
          field: 'contract_expiry',
          fpFieldType:"custom_date",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Program Code',
          field: 'pgm_code',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable:false,
      },
      {
          label: 'Unit Status',
          field: 'unit_status',
          fpFieldType:"option",
          hidden:true,
          filterable: true,//use only for filter in schedule report
          sortable:false
      }
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'unit_permit_detail') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{

    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/unit-permit-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action:self.action,


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              // self.loadList();

            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'unit-permit-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/UnitPermitDetail.vue